export default {
    m: {
        topAlert: {
            detail: '点击查看详情'
        },
        bannerSearch: {
            MyTicket: '我的工单',
            submit: "创建工单",
            results: '搜索结果'
        },
        header: {
            support: "客服首页",
            server: "服务器状态",
            known: "已知问题",
            submit: "创建工单",
            sign: "登录",
            ticket: "我的工单",
            play: "帮助中心",
            out: '退出登录',
            media: "媒体资源",
            supportup: "帮助中心",
            forum: "论坛",
            creators: "活动",
            en: "Global - English",
            zh: "中国 - 中文",

        },
        banner: {
            title: "需要什么帮助?",
            support: "客服首页",
            search: '搜索相关文章'
        },
        home: {
            tabsTitle: "请选择类别",
            tabsTitles: "",
        },

        contact: {
            title: "现有内容不能解决你的问题?",
            pone: "请创建工单告诉我们你的问题",
            ptwo: "我们会尽快回复"
        },
        search: {
            one:" 条搜索结果",
            res: " 条搜索结果",
            emply:'没有找到相关文章',
        },
        topic: {
            all: '查看所有文章'
        },
        article: {
            office: 'Party Animals',
            help: '这篇文章是否有帮助?',
            yes: '是',
            no: '否',
            copy: "复制链接",
            copysuccess:"复制成功!",
        },

        feature: {
            title: "推荐文章"
        },
        submit: {
            btn: "SUBMIT A TRACKET"
        },
        login: {
            title: '登录',
            pone: ' 请选择第三方帐号进行登录 ',
            ptwo: '',
            wechat: '微信登录',

            qq: 'QQ 登录',
            google: ' Google 账号登录',
            facebook: ' Facebook 账号登录',
            steam: ' Steam 账号登录',
            xbox: ' Xbox Live 账号登录',
            text:'已阅读并同意',
            and:'、',
            eula: '《用户协议》',
            privacy: '《隐私政策》',
            alert:"此项不能为空",
           
        },
        footer: {
            download: "资源下载",
            follow: "关注我们",
            eula: "用户协议",
            privacy: "隐私政策",
            playersupport: "玩家支持",
            press: "媒体和评测",
            business: "商务合作",
            kit: '媒体包',
            on: "关注我们",
        },
        ticket: {
            limit: "支持文件格式：jpg、jpeg、png、gif、mpg、mpeg、xls、xlsx、ppt、pptx、doc、docx、pdf、word、txt、mp3、mp4、avi、amr、wav、m4a、mov、eml、csv、rar、zip、gz 文件总大小需小于 50MB",
            alert1: '此项不能为空',
            title: "创建工单",
            email: "Email",
            support: "Support ID",
            type: "Type of Issue",
            subcate: "Subcategory",
            subject: "Subject",
            des: "Description",
            attach: "附件",
            attachafter: " (选填)",
            alert: "PLEASE NOTE: This is required to solve most issues. We can assist much quicker with this information. Support ID can be found in the Profile tab of the in-game settings.",
            alerttwo: "Please enter details of your request, including as much information as possible.",
            policy: "我确认我年龄在 13 岁以上并且已阅读并接收",
            policytwo: "PA 隐私声明",
            policythree: "请注意，所提供的任何反馈或建议都要遵守",
            policyfour: "Party Animals 的服务条款",
            policyfive: "，包括有关反馈的具体条款。",
            submit: "发送",
            MyTicket: "我的工单",
            cap: "验证码",
            codeAlert:"请输入正确验证码",
            custid: "客服编号",
            codeplace:"请输入验证码",
            custplace:`客服编号位置：游戏设置 - 通用 - 我的客服编号`,
        },
        myticket: {
            sub: '标题',
            ticket: '工单 ID',
            last: '最新更新时间',
            status: "工单状态",
            search: "搜索工单",
        },
        ticketdetail: {
            emply: '此项不能为空',
            office: 'Party Animals',
            id: "发送",
            create: '创建时间',
            support: '客服编号',
            email: '客服编号',
            statu: "工单状态",
            type: "输入回复",
            drop: "点击或",
            dropa: "拖拽添加附件",
            dropShort:'点击添加附件',
            sub: "提交",
            relpy:"输入回复"
        },
        nfind: {
            back: "返回首页"
        },
        server: {
            running: '所有服务器都已启动并运行',
            error: "服务器受限",
            update: "最后更新于 1 分钟前",
            status: "状态图例",
            runningsmall: "运行正常",
            limit: "使用受限",
            bigerror: "严重问题或服务中断",
            serve: "服务器状态",
            article: "相关文章",
            report: "报告服务异常",
            detail: "如果猛兽派对服务器异常，请告诉我们",
            repbtn: "提交报告",
            help: "仍需要帮助?",
            detail1: "请创建工单告诉我们你的问题，我们会尽快回复",
            repbtn1: "创建工单",

            Announcement: "公告系统",
            Room: "自定义房间",
            Matching: "快速游戏",
            Login: "登录",
            OfficialSite: "官方网站",
            Store: "商店",
            FriendChat: "好友与聊天",


            reportTitle:"报告服务异常",
            reportTxt:"你遇到了什么问题？",
            reportOne:"请选择遇到异常的服务器",
            reportSec:"",
            reportTwo:"请描述遇到的问题（选填）",
            reportPlace:"",

            close:"取消",
            submit:"提交",
        },
        bind:{
            title:"绑定客服编号",
            span:"绑定客服编号可以让我们更快地帮你解决问题",
            step:"1. 在游戏内点击“游戏设置”",
            steptwo:"2. 在“通用”选项卡内拉到页面底部，找到“我的客服编号”，点击查看",
            stepthree:"3. 点击“显示”图标，显示你的客服编号，点击编号复制",
            inputTitle:"客服编号",
            inputPlace:"请输入客服编号",
            alert:"客服编号无效，请重新输入 ",
            alertBind:"该客服编号已被绑定，请重新输入",
            jump:"跳过",
            post:"绑定",
            postTitle:"绑定成功",
            postSpan:"已成功绑定客服编号",
            postHome:"客服首页",
            emply:"客服编号无效，请重新输入 ",
            hasbind:"该客服编号已被绑定，请重新输入",
        },
        notfind:{
            title:'404 错误',
            txt:"糟糕！找不到您要查找的页面",
            btn:'客服首页',
        }
    }
}